 <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h6 class="modal-title">{{ 'personmodal.header' | trans }}</h6>
          <button #closepersonmodal type="button" class="close" data-dismiss="modal" (click)="resetModal()">&times;</button>
        </div>
        <div class="modal-body">
            <div class="row flex-nowrap">
            <div class="col-5 ml-0">
              <app-personimage [bigimg]="true" [enableChange]="false" [personId]="modalpersonId"></app-personimage>
            </div>
            <div class="col-7">
              <table class="table table-borderless">
                <tr>
                  <td><p class="mb-0 font-weight-lighter f-13">{{ 'personmodal.name' | trans }}</p></td>
                  <td><p class="mb-0 font-weight-light f-13 text-truncate">{{ personDetail?.membername}}</p></td>
                </tr>
                <tr *ngIf="!showPending">
                  <td><p class="mb-0 font-weight-lighter f-13">{{ 'personmodal.function' | trans }}</p></td>
                  <td><p class="mb-0 font-weight-light f-13">{{ personDetail?.member_function }}</p></td>
                </tr>
                <tr>
                  <td><p class="mb-0 font-weight-lighter f-13">{{ 'personmodal.phone' | trans }}</p></td>
                  <td><p class="mb-0 font-weight-light f-13">{{ personDetail?.phone}}</p></td>
                </tr>
                <tr>
                  <td><p class="mb-0 font-weight-lighter f-13">IM</p></td>
                  <td><p class="mb-0 font-weight-light f-13">{{ personDetail?.im}}</p></td>
                </tr>
              </table>
            </div>
          </div>
            <div class="row">
              <div class="col p-0">
                <div *ngIf="showKickMember && !showSuccess" class="alert alert-danger">
                  {{ 'personmodal.kickalert' | trans }}
               </div>
              </div>
            </div>
            <div *ngIf="relationerror" class="row">
              <div  class="alert alert-danger" role="alert">
                {{ 'personmodal.nofunction' | trans }}
              </div>
            </div>
             <div class="row">
              <div *ngIf="canEditRelation" class="col">
                <button *ngIf="!showKickMember" (click)="toggleEditRelation()" class="btn d-block w-100">
                  <h6 class="btn-text">{{ 'personmodal.editperson' | trans }}  
                    <i matTooltipPosition="above" matTooltipShowDelay="500" class="material-icons align-middle f-15 pl-1 zoom cursor-pointer">
                    admin_panel_settings
                    </i></h6></button>
              </div>
              <div *ngIf="canKickMember" class="col">
                <button *ngIf="!showKickMember" (click)="toggleKickMember()" class="btn d-block w-100">
                  <h6 class="btn-text">{{ 'personmodal.deletefromorg' | trans }}<i matTooltipPosition="above" matTooltipShowDelay="500" class="material-icons align-middle f-15 pl-1 zoom cursor-pointer">
                  person_remove
                  </i></h6></button>
              </div>
        
             </div>
             <div *ngIf="showKickMember && !showSuccess" class="row">
              <div class="col">
                <button *ngIf="showKickMember && !showSuccess" (click)="toggleKickMember()" class="btn d-block w-100"><p class="btn-text">{{ 'personmodal.cancel' | trans }}</p></button>
              </div>
             </div>
             <div *ngIf="showKickMember && !showSuccess" class="row mt-3">
              <div class="col">
                <button *ngIf="showKickMember && !showSuccess" (click)="kickMember()" class="btn-close w-100"><p class="btn-save-text">{{ 'personmodal.remove' | trans }} {{ personDetail?.membername }}</p></button>
              </div>
             </div>
             
          <div *ngIf="showSuccess" class="row">
            <div  class="alert alert-success" role="alert">
              {{ personDetail?.membername }} {{ 'personmodal.hasbeenremoved' | trans }}  
            </div>
          </div>
          <div *ngIf="showEditRelation">
            <div class="row pt-3">
              <div *ngIf="canChangeUserType" class="col-3">
                <label><p class="mb-0 font-weight-lighter pl-0 f-13">{{ 'personmodal.userrole' | trans }}</p></label>
                </div>
                <div class="col-9">
                  <input type="text" class="form-control pr-3 f-13"  placeholder="{{ 'personmodal.positionhelp' | trans }}" [(ngModel)]="personDetail.member_function">
                </div>
            </div>
            <div class="row pt-3">
              <div class="col-3">
                <label><p class="mb-0 font-weight-lighter pl-0 f-13">FTE (0-1)</p></label>
              </div>
              <div class="col-9">
                <input type="number" min="0" max="1" step="0.1" class="form-control pr-3 f-13" placeholder="0.5" [(ngModel)]="personDetail.fte">
              </div>
            </div>
            <div *ngIf="canChangeUserType" class="row pt-3">
                <div class="col-4">
                  <label><p class="mb-0 font-weight-lighter f-13">{{ 'personmodal.userpostion' | trans }}</p></label>
                  </div>
                  <div *ngIf="canChangeUserType" class="col-4">
                    <button (click)="personDetail.relationtype = 'Admin'" id ="button-user-select" [ngClass]="{'btn-user-selected': personDetail.relationtype == 'Admin','btn-user-select': personDetail.relationtype != 'Admin' }" class="btn btn-user-select w-100"><p class="btn-text">{{ 'personmodal.admin' | trans }}</p></button>
                </div>
                <div *ngIf="canChangeUserType" class="col-4">
                  <button (click)="personDetail.relationtype = 'Member'" [ngClass]="{'btn-user-selected': personDetail.relationtype == 'Member','btn-user-select': personDetail.relationtype != 'Member' }" class="btn btn-user-select w-100"><p class="btn-text">{{ 'personmodal.user' | trans }}</p></button>
              </div>
            </div>
            <div (click)="activeusertoggle()" class="row pt-2">
              <div class="col-5">                  
                <label class="mb-0 font-weight-lighter f-13" for="sendinvite">{{ 'personmodal.sendemailinvite' | trans }}</label>
              </div>
              <div class="col">     
                <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="inlineCheckbox1" name="invite" [(ngModel)]="personDetail.sendinvite" >
              </div>
            </div>
            </div>
            <div class="row pt-2" (click)="activeusertoggle()">
              <div *ngIf="!personDetail.sendinvite" class="col ml-3 mr-3 alert alert-secondary w-100" role="alert">
                <p class="mb-0">{{ 'personmodal.sendalert' | trans }}</p>
              </div>
              <div *ngIf="personDetail.sendinvite" class="col ml-3 mr-3 alert alert-success w-100" role="alert">
                <p class="mb-0">{{ 'personmodal.sendalert2' | trans }}</p>
              </div>
            </div>
            <div class="row" style="margin-top:15px;">
              <div class="col pl-3 pr-3">
                <button (click)="toggleEditRelation()" style="height:35px; display:list-item;" class="btn-close"><h6 class="btn-save-text">{{ 'personmodal.cancel' | trans }}</h6></button>
              </div>
              <div class="col pl-3 pr-3">
                <button (click)="saveRelation()" style="height:35px; display:list-item;" class="btn-save"><h6 class="btn-save-text">{{ 'personmodal.savechanges' | trans }}</h6></button>
              </div>
            </div>
           </div>
      </div>
</div>    
